import React, { Fragment, useState } from "react";
import { Button, useMutation, useNotify, useRefresh } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Typography,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { StyledButton } from "../../../components/ListShowButton";

interface IDeleteButton {
  id: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
  form: {
    "& .MuiCardContent-root": {
      padding: 0,
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
});

const ConfirmButton = ({ id }: IDeleteButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleDelete, { loading }] = useMutation(
    {
      type: "delete",
      resource: `subcontractorAdjustmentPrices`,
      payload: {
        id,
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully delete adjustment price.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed delete adjustment price, error: ${error.message}`,
          "warning",
        ),
    },
  );

  return (
    <Button
      onClick={handleDelete}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      disabled={loading}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const DeleteButton = ({ id }: IDeleteButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <StyledButton
        variant="outlined"
        onClick={handleOpenDialog}
        style={{ color: "#f44336", borderColor: "#f44336" }}
      >
        Delete
      </StyledButton>

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Delete The Adjustment Price
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            <Typography variant="body1" gutterBottom>
              Are you sure you want to delete the adjustment price?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Back"
            color="secondary"
            onClick={handleClose}
            className={classes.cancelButton}
          />
          <ConfirmButton id={id} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DeleteButton;
